import { MyProfile } from '@/types/my-profile.type';

export type MyProfileResponse = {
  user: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
    photo_url?: string | null;
    role?: string | null;
  };
  profile: {
    city?: string | null;
    state?: string | null;
    zip_code?: string | null;
    address?: string | null;
    linkedin?: string | null;
    meeting_link?: string | null;
    website?: string | null;
    preferred_markets?: string[] | null;
  };
  role_profile: {
    consultant_firm_affiliated?: string[] | null;
  };
};

export type SaveMyProfileApiPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  photo_url?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  address?: string | null;
  meeting_link?: string | null;
  linkedin?: string | null;
  website?: string | null;
  preferred_markets?: string[];
  consultant_firm_affiliated?: string[];
};

export const mapSaveMyProfilePayloadToRequest = (
  payload: SaveMyProfileApiPayload
) => ({
  user: {
    first_name: payload.first_name,
    last_name: payload.last_name,
    email: payload.email,
    phone: payload.phone,
    photo_url: payload.photo_url ?? null,
  },
  profile: {
    city: payload.city ?? null,
    state: payload.state ?? null,
    zip_code: payload.zip_code ?? null,
    address: payload.address ?? null,
    linkedin: payload.linkedin ?? null,
    meeting_link: payload.meeting_link ?? null,
    website: payload.website ?? null,
    preferred_markets: payload.preferred_markets ?? [],
  },
  role_profile: {
    consultant_firm_affiliated: payload.consultant_firm_affiliated ?? [],
  },
});

export const mapMyProfileResponseToMyProfile = (
  profile: MyProfileResponse
): MyProfile => ({
  id: profile.user.id,
  first_name: profile.user.first_name || '',
  last_name: profile.user.last_name || '',
  photo_url: profile.user.photo_url || '',
  city: profile.profile.city || '',
  state: profile.profile.state || '',
  zip_code: profile.profile.zip_code || '',
  address: profile.profile.address || '',
  phone: profile.user.phone || '',
  email: profile.user.email || '',
  meeting_link: profile.profile.meeting_link || '',
  linkedin: profile.profile.linkedin || '',
  website: profile.profile.website || '',
  preferred_markets: profile.profile.preferred_markets || [],
  consultant_firm_affiliated:
    profile.role_profile.consultant_firm_affiliated || [],
  user_role: profile.user.role || undefined,
});
